import { URLS } from 'config';
import { ApiMutationConfig, PostScheduleTriggerParams } from '../types';
import { createApiEndpoint } from '../utils';
import { UpsertSchedule } from './types';

const schedulesUrl = `${URLS.app}/api/ServiceSequenceSchedules`;

type PostScheduleConfig = ApiMutationConfig<UpsertSchedule, unknown, number>;

export const postSchedule = createApiEndpoint<PostScheduleConfig>({
  url: schedulesUrl,
  method: 'POST',
});

type PostScheduleStatusBody = {
  Id: number;
  Active: boolean;
  OrganizationId: number;
};

type PostScheduleStatusConfig = ApiMutationConfig<
  PostScheduleStatusBody,
  unknown,
  number
>;

export const postScheduleStatus = createApiEndpoint<PostScheduleStatusConfig>({
  url: `${schedulesUrl}/status`,
  method: 'POST',
});

type PostScheduleTriggerConfig = ApiMutationConfig<
  unknown,
  PostScheduleTriggerParams
>;

export const postScheduleTrigger = createApiEndpoint<PostScheduleTriggerConfig>(
  {
    url: `${schedulesUrl}/$scheduleId/trigger`,
    method: 'POST',
  },
);

type PostScheduleArchiveConfig = ApiMutationConfig<
  unknown,
  { $scheduleId: number }
>;

export const deleteSchedule = createApiEndpoint<PostScheduleArchiveConfig>({
  url: `${schedulesUrl}/$scheduleId/archive`,
  method: 'DELETE',
});
